
































































































import {
    defineComponent,
    onMounted,
    reactive,
    toRefs,
    ref,
} from '@vue/composition-api';
import { GlobalModel } from '@/views/model';
import { useApolloModel } from 'vue-apollo-model';
import StepInfo from './components/step-info.vue';
import StepEmail from './components/step-email.vue';
import StepCert from '@/components/qualification/step-cert.vue';
import CheckTruth from '@/components/qualification/check-truth.vue';
import { enumUserStatus } from '@/type/enums';
import PageFooter from '@/components/page-footer/index.vue';
import RegisterStatus from './register-status.vue';
import { handleErrorMessageToast } from '@/common/util';
import { RegStatusMap } from './const';
import { IframeOp } from '@/components/qualification/enums';
import { emailVerify } from '@api/register';
import { logout } from '@/common/logout';
import { setUserSts } from '@/utils/account-sts';

export default defineComponent({
    name: 'register',
    components: {
        StepInfo,
        StepEmail,
        StepCert,
        PageFooter,
        RegisterStatus,
        CheckTruth
    },
    setup(props, context) {
        const model = useApolloModel(GlobalModel);
        const state = reactive({
            linkStatus: RegStatusMap.NOT_SUBMIT,
            stepActive: 0,
            isCert: false,
            buttonMsg: '下一步',
            bindInfo: {},
            reFillInfo: {},
            isEnd: false, // isEnd为true是补充邮箱逻辑，只走前两步
            isLoading: true
        });
        const bindMail = [
            {
                desc: '绑定邮箱',
                buttonMsg: '下一步',
            },
            {
                desc: '邮箱激活',
                buttonMsg: '前往激活',
            },
        ];

        const registerCount = ref([
            {
                desc: '基本信息填写',
                buttonMsg: '下一步',
            },
            {
                desc: '邮箱激活',
                buttonMsg: '前往激活',
            },
            {
                desc: '企业资质认证',
                buttonMsg: '下一步',
            },
            {
                desc: '真实性验证'
            }
        ]);
        const currentBreadcrumb = ref('账号注册');
        async function getStatus() {
            await model.updateStatus();

            switch (model.status) {
                case enumUserStatus.registerReject:
                case enumUserStatus.registerNew:
                    state.stepActive = 2;
                    state.isCert = true;
                    break;
                case enumUserStatus.noRegisterReady:
                    registerCount.value = bindMail;
                    currentBreadcrumb.value = '补充邮箱';
                    state.isEnd = true;
                    break;
                case enumUserStatus.registerReview:
                    state.stepActive = 2;
                    break;
                case enumUserStatus.registerReady:
                    break;
                case enumUserStatus.noRegisterReview:
                case enumUserStatus.noRegisterReject:
                case enumUserStatus.noRegisterExpired:
                    context.root.$message.warning(
                        '该账号在其他平台存在进行中的身份认证',
                    );
                    break;
                case enumUserStatus.registerWaitTruth:
                case enumUserStatus.registerTruthReview:
                    state.stepActive = 3;
                    break;
                case enumUserStatus.registerTruthFailed:
                    state.stepActive = 3;
                    break;
                default:
                    break;
            }
        }
        async function getRegStatus() {
            state.isLoading = true;
            const res = await emailVerify({
                verifyToken: (context.root.$route.query.token as string) ?? '',
                verifyType: 'link',
                platTag: 1,
            });
            if (res.result === 100200584 || res.result === 100200583) {
                // token过期
                state.linkStatus = RegStatusMap.IS_OUTDATE;
            } else if (res.result === 100200581) {
                state.linkStatus = RegStatusMap.IS_PASS;
            } else if (res.result !== 1) {
                state.linkStatus = RegStatusMap.NOT_SUBMIT;
                state.stepActive = 0;
            } else {
                try {
                    state.linkStatus = res.data.accountStatus;
                    if (res.data.accountStatus === 0) {
                        state.stepActive = 2;
                        state.isCert = true;

                        await setUserSts({ globalTicket: res.data.globalTicket });
                    }
                } catch (e) {
                    handleErrorMessageToast(JSON.stringify(e) + '，请刷新重试');
                }
            }
            state.isLoading = false;
        }
        onMounted(async () => {
            if (!context.root.$route.query.token) {
                await getStatus();
                state.isLoading = false;
                return;
            }
            getRegStatus();
        });

        function getStepIndex(stepIndex: number, info: any) {
            if (registerCount.value.length === stepIndex + 1) {
                state.buttonMsg = '提交';
            }
            if (registerCount.value.length === stepIndex + 2) {
                state.buttonMsg = '前往激活';
            }
            if (info) {
                state.reFillInfo = info;
            } else {
                state.reFillInfo = '';
            }
            state.stepActive = stepIndex;
        }

        function getbindInfo(bindInfo: object) {
            state.bindInfo = bindInfo;
        }
        function exitRegister() {
            context.root.$router.push({
                name: 'index'
            });
            // logout();
        }

        async function checkTruthBack(op: IframeOp) {
            await model.updateStatus();

            if (op === IframeOp.ModifyQualification) {
                state.stepActive = 2;
            }
        }

        return {
            getStepIndex,
            RegStatusMap,
            registerCount,
            getbindInfo,
            model,
            exitRegister,
            checkTruthBack,
            enumUserStatus,
            ...toRefs(state),
        };
    },
});
